import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { Mode } from '../../general-types';
import { challengeTutorialService } from '../services/challengeTutorialService';

class ChallengeTutorialStore {
  open: boolean = false;
  showAgain: boolean = false;
  mode: Mode | null = null;
  videoUrl: string | null = null;
  private userId: number | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.open = false;
    this.showAgain = false;
    this.mode = null;
    this.videoUrl = null;
    this.userId = null;
  }

  async getModalStatus(userId: number) {
    const { show } = await challengeTutorialService.getShowStatus(userId);

    this.setUserId(userId);
    this.setOpen(show);
    this.setShowAgain(show);
    this.setMode(show ? 'EDIT' : 'VIEW');
  }

  async getVideoUrl() {
    const { videoUrl } = await challengeTutorialService.getVideo();

    this.setVideoUrl(videoUrl);
  }

  openModal(mode: Mode) {
    this.setOpen(true);
    this.setMode(mode);
  }

  closeModal() {
    this.setOpen(false);
  }

  async changeShowAgain(checked: boolean) {
    if (!this.userId) {
      console.error('User ID is not set');
      return;
    }

    const { show } = await challengeTutorialService.updateShowStatus(
      this.userId,
      checked,
    );

    this.setShowAgain(show);
  }

  private setOpen = (open: boolean) => {
    this.open = open;
  };

  private setShowAgain = (showAgain: boolean) => {
    this.showAgain = showAgain;
  };

  private setMode = (mode: Mode | null) => {
    this.mode = mode;
  };

  private setVideoUrl = (videoUrl: string) => {
    this.videoUrl = videoUrl;
  };

  private setUserId = (userId: number) => {
    this.userId = userId;
  };
}

const challengeTutorialStore = new ChallengeTutorialStore();
resetAllStore.addResetMethod(challengeTutorialStore.setDefaultValues);

export { challengeTutorialStore };
